/**
 * Type utilities for working with objects and type checking
 */

export const isObject = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === "object" && !Array.isArray(value);

export const hasKeys = (obj: Record<string, unknown>): boolean => Object.keys(obj).length > 0;

/**
 * Recursively removes undefined properties and empty objects (mutates original)
 */
export function removeUndefinedProperties<T>(obj: T): void {
  if (!isObject(obj)) {
    return;
  }

  const keys = Object.keys(obj);

  for (const key of keys) {
    const value = obj[key];

    if (value === undefined) {
      delete obj[key];
    } else if (isObject(value)) {
      if (value.constructor === Object) {
        removeUndefinedProperties(value);

        if (!hasKeys(value)) {
          delete obj[key];
        }
      }
    }
  }
}
